/* ==========================================================================
   Logo Carousel Section
   Path: assets/logo-carousel.js
   Loaded from: sections/logo-carousel.liquid
   Handles: optional auto-scrolling behavior, duplicating logos for a
   seamless infinite loop, pause-on-hover, drag-to-scroll for desktop,
   and Shopify theme editor live refresh support.
   ========================================================================== */

(function () {
  'use strict';

  function setupDragToScroll(root) {
    var wrapper = root.querySelector('.logo-carousel__track-wrapper');
    if (!wrapper || wrapper.dataset.dragBound) return;
    wrapper.dataset.dragBound = 'true';

    var isDown = false;
    var startX = 0;
    var startScrollLeft = 0;
    var moved = false;

    function isScrollEnabledForViewport() {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      if (isMobile) {
        return root.classList.contains('logo-carousel--scroll-mobile');
      }
      return root.classList.contains('logo-carousel--scroll-desktop');
    }

    wrapper.addEventListener('pointerdown', function (e) {
      if (!isScrollEnabledForViewport()) return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScrollLeft = wrapper.scrollLeft;
      wrapper.setPointerCapture(e.pointerId);
    });

    wrapper.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var delta = e.clientX - startX;
      if (Math.abs(delta) > 3) moved = true;
      wrapper.scrollLeft = startScrollLeft - delta;
    });

    function endDrag() {
      isDown = false;
    }
    wrapper.addEventListener('pointerup', endDrag);
    wrapper.addEventListener('pointercancel', endDrag);
    wrapper.addEventListener('pointerleave', endDrag);

    // Prevent accidental link clicks right after a drag.
    wrapper.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  function setupCarousel(root) {
    if (!root) return;

    var isAutoplay = root.dataset.autoplay === 'true';
    var speed = parseFloat(root.dataset.speed) || 20;
    var track = root.querySelector('.logo-carousel__track');

    if (!track) return;

    root.style.setProperty('--lc-speed', speed + 's');

    var scrollDesktop = root.dataset.scrollDesktop === 'true';
    var scrollMobile = root.dataset.scrollMobile === 'true';
    if (!isAutoplay && (scrollDesktop || scrollMobile)) {
      setupDragToScroll(root);
    }

    if (!isAutoplay) return;

    // Duplicate the logo list once so the CSS animation (-50% translateX)
    // creates a seamless infinite loop.
    if (!track.dataset.cloned) {
      var clone = track.innerHTML;
      track.insertAdjacentHTML('beforeend', clone);
      track.dataset.cloned = 'true';
    }

    // Pause the animation on hover / focus for accessibility and usability.
    root.addEventListener('mouseenter', function () {
      root.classList.add('logo-carousel--paused');
    });
    root.addEventListener('mouseleave', function () {
      root.classList.remove('logo-carousel--paused');
    });
    root.addEventListener('focusin', function () {
      root.classList.add('logo-carousel--paused');
    });
    root.addEventListener('focusout', function () {
      root.classList.remove('logo-carousel--paused');
    });
  }

  function initAll(context) {
    var scope = context || document;
    var sections = scope.querySelectorAll('.logo-carousel');
    sections.forEach(function (section) {
      setupCarousel(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  // Re-init when a merchant edits this section in the Shopify theme editor,
  // since settings changes reload the section markup via AJAX.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.logo-carousel')) {
      initAll(event.target);
    }
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (event.target.querySelector('.logo-carousel')) {
      initAll(event.target);
    }
  });
})();